module.exports = __webpack_public_path__ + "img/yt-social-icon.f11edbbb.svg";